/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAddress } from './ControlAddress';
import {
    ControlAddressFromJSON,
    ControlAddressFromJSONTyped,
    ControlAddressToJSON,
} from './ControlAddress';
import type { ControlEntityList } from './ControlEntityList';
import {
    ControlEntityListFromJSON,
    ControlEntityListFromJSONTyped,
    ControlEntityListToJSON,
} from './ControlEntityList';

/**
 * 
 * @export
 * @interface ControlOrganizationMatch
 */
export interface ControlOrganizationMatch {
    /**
     * 
     * @type {string}
     * @memberof ControlOrganizationMatch
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlOrganizationMatch
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlOrganizationMatch
     */
    domains: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ControlOrganizationMatch
     */
    status: number;
    /**
     * 
     * @type {ControlAddress}
     * @memberof ControlOrganizationMatch
     */
    address: ControlAddress;
    /**
     * 
     * @type {Array<ControlEntityList>}
     * @memberof ControlOrganizationMatch
     */
    associated_entities: Array<ControlEntityList>;
    /**
     * 
     * @type {number}
     * @memberof ControlOrganizationMatch
     */
    confidence_level: number;
}

/**
 * Check if a given object implements the ControlOrganizationMatch interface.
 */
export function instanceOfControlOrganizationMatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "associated_entities" in value;
    isInstance = isInstance && "confidence_level" in value;

    return isInstance;
}

export function ControlOrganizationMatchFromJSON(json: any): ControlOrganizationMatch {
    return ControlOrganizationMatchFromJSONTyped(json, false);
}

export function ControlOrganizationMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlOrganizationMatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'domains': json['domains'],
        'status': json['status'],
        'address': ControlAddressFromJSON(json['address']),
        'associated_entities': ((json['associated_entities'] as Array<any>).map(ControlEntityListFromJSON)),
        'confidence_level': json['confidence_level'],
    };
}

export function ControlOrganizationMatchToJSON(value?: ControlOrganizationMatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'domains': value.domains,
        'status': value.status,
        'address': ControlAddressToJSON(value.address),
        'associated_entities': ((value.associated_entities as Array<any>).map(ControlEntityListToJSON)),
        'confidence_level': value.confidence_level,
    };
}

